import RsmLogo from './RsmLogo'

export default RsmLogo
